import { Injectable } from '@angular/core';
import { RouteService } from './route.service';
import { AuthService } from './auth.service';
import { Roles } from 'src/app/shared/enums/role.enum';
import { Column } from '../state/_models/form.model';
import * as moment from 'moment';
@Injectable({
  providedIn: 'root'
})
export class ReportRecordService {

  constructor(
    private readonly authService: AuthService,
    private readonly route: RouteService
  ) { }

  isAdminOrSuperAdmin = () =>
    this.authService.userProfile?.Role === Roles.superAdmin ||
    this.authService.userProfile?.Role === Roles.admin;

  isAuthorizedParticipant(right: string, tableId: string = this.route.getTableKey() ?? ''): boolean {
    if (
      this.route.currentRoute().includes('reports/datatable/view') ||
      this.route.currentRoute().includes('reports/details/view') ||
      this.route.currentRoute().includes('forms/action/edit')
    ) {
      let applicationRoles: any =
        this.authService.userProfile?.ApplicationRoles;

      let createRight = 0;
      let viewRight = 0;
      let updateRight = 0;
      let deleteRight = 0;
      let rights = {
        manageReports:0,
        manageForms:0
      };

      const setManageReports = (el:any) => {
        if (el.ApplicationKey === this.route.getApplicationKey()) {
          el.ApplicationRoleManagements?.forEach((role:any) => {
            if (role.ApplicationTableKey === tableId && role.ApplicationRoleManagementType?.Name === 'Manage Reports') {
              rights.manageReports = 1;
            }
          });
        }
      };
      const setManageForms = (el:any) => {
        if (el.ApplicationKey === this.route.getApplicationKey()) {
          el.ApplicationRoleManagements?.forEach((role:any) => {
            if (role.ApplicationTableKey === tableId && role.ApplicationRoleManagementType?.Name === 'Manage Forms') {
              rights.manageForms = 1;
            }
          });
        }
      };

      if (applicationRoles != undefined) {
        applicationRoles.forEach((el: any) => {
          if (
            el.ApplicationKey == this.route.getApplicationKey() ||
            el.ApplicationId == this.route.getApplicationKey()
          ) {
            el.Rights.forEach((permission: any) => {
              if (
                permission.ApplicationTableKey === tableId ||
                permission.ApplicationTableId == tableId
              ) {
                createRight = permission.Create;
                viewRight = permission.View;
                updateRight = permission.Update;
                deleteRight = permission.Delete;
              }
            });
          }
        });
      }

      switch (right) {
        case 'addRecord':
          return createRight === 1;
        case 'viewRecord':
          return viewRight === 1;
        case 'editRecord':
          return updateRight === 1;
        case 'deleteRecord':
          return deleteRight === 1;
        case 'editForm':
          applicationRoles?.forEach(setManageForms);
          return rights.manageForms === 1;
        case 'editReport':
          applicationRoles?.forEach(setManageReports);
          return rights.manageReports === 1;
        default:
          return false;
      }
    }
    return false;
  }

  scrollTabs(direction: 'left' | 'right', navElement: any): void {
    const tabList = navElement; // Reference to the ul element
    const scrollAmount = 250; // Adjust as needed

    if (direction === 'left') {
      tabList.scrollLeft -= scrollAmount;
    } else {
      tabList.scrollLeft += scrollAmount;
    }
  }

  getDocumentRequestLink(col: Column, recordId: string): void {
    window.open(
      '/apps/' +
      this.route.getApplicationKey() +
      '/tables/' +
      col.ApplicationTableKey +
      '/doc-sign-request/' +
      recordId +
      '/' +
      col.FieldKey,
      '_blank'
    );
  }

  getFormattedValue(
    type: string,
    value: any,
    isFromEdit: boolean = false,
    isRelated: boolean = false
  ) {
    if (!value && type !== 'TINYINT(1)') return ''; // common guard

    switch (type) {
      case 'TINYINT(1)': {
        const returnValue = value ? 'True' : 'False';
        return isRelated ? value : returnValue;
      }

      case 'DATE': {
        if (!isFromEdit) break; // only applies for edit mode
        const date = moment(value, isRelated ? undefined : 'YYYY-MM-DD');
        return date.format(isRelated ? 'MM/DD/yyyy' : 'MM/DD/YYYY');
      }

      case 'DATETIME': {
        if (!isFromEdit) break; // only applies for edit mode
        return isRelated
          ? value
          : moment(value)
            .format('MM/DD/YYYY hh:mm A');
      }

      case 'DECIMAL(20,2)': {
        const [intPart, decimalPart] = value.toString().split('.');
        const isNegative = intPart.startsWith('-');
        const absoluteValue = isNegative ? intPart.slice(1) : intPart;
        const formattedValue =
          '$' + this.separator(absoluteValue) + (decimalPart ? '.' + decimalPart : '');
        return isNegative ? '-' + formattedValue : formattedValue;
      }

      case 'VARCHAR(15)': {
        const stringValue = value.toString();
        return stringValue.replace(/(\d{3})(\d{3})(\d{4})/, '($1) $2-$3');
      }

      case 'USER': {
        if (value === this.authService.userProfile.Email) {
          return 'Current User';
        }
        break;
      }

      default:
        break;
    }

    return value ?? '';
  }

  separator = (str: string): any => {
    if (!str || str?.length <= 3) return str;
    return (
      this.separator(str.substring(0, str.length - 3)) +
      ',' +
      str.slice(str.length - 3)
    );
  };
}
